import { AppRouteRecordRaw } from '../types';

const VoucherLandingPage = () => import('@/pages/promo/VoucherLandingPage.vue');

/**
 * Public co-branded voucher landing pages.
 *
 * These are the only routes in the portal that render for anonymous visitors.
 * The `/promo/` prefix is allow-listed in the global auth guard
 * (router/index.ts); adding a route here without that prefix would bounce
 * visitors to /auth/login.
 *
 * Campaign slugs are defined in `@/pages/promo/promo.campaigns.ts` and must
 * match the backend registry in rp-users. Today that is:
 *   /promo/stellantis-premium
 *   /promo/stellantis-standard
 *
 * Deliberately NO `meta.requiredRoles`/`requiredUserGroup`/etc. — any of those
 * would flip `requiresAuthCheck` on and dereference a null `userAddData`.
 */
export const promoRoutes: AppRouteRecordRaw[] = [
  {
    path: '/promo/:slug',
    name: 'promoVoucherLanding',
    component: VoucherLandingPage,
    meta: {
      // Set per campaign in the page itself; this is only the pre-hydration title.
      title: 'ryd',
    },
  },
];
